import { AlignLeftIcon, ChevronLeft } from "lucide-react";
import React from "react";
import './css/TopBar.css'
import { useNavigate } from 'react-router-dom';

const TopBar = ({title})=>{
    const navigate = useNavigate();

    return(<>
    <div style={{paddingTop:'50px'}}>
    <div className="topbar">
<ChevronLeft onClick={() => navigate(-1)} />
        {title}
    </div>
    </div> 
    </>);

}
export default TopBar;